import { OrderModel } from '../preliminaries/order.model';
import { InternalOrderModel } from '../shopping/internal-order.model';
import { InvoiceModel } from './../invoicing/invoice.model';
import { DevolutionModel } from './../rental/devolution.model';
import { InventoryOutputStateEnums } from "src/app/enum/inventory-output-state-enums";
import { InventoryModel } from './inventory.model';

export class InventoryOutputModel {
  inventoryOutputId: number = 0;
  inventoryId: number = 0;
  inventory: InventoryModel | null = null;
  branchId: number = 0;
  inventoryOutputTypeId: number = 0;
  consecutive: number = 0;
  dateOutput: Date = new Date();
  inventoryPeriodId: number = 0;
  inventoryOutputStateId: number = InventoryOutputStateEnums.open;
  conceptId: number = 0;
  clientId: number = 0;
  deliveryDocument: string | null = null;
  observation: string | null = null;
  transportValue: number = 0;
  totalValue: number = 0;
  devolutionId: number | null = null;
  devolution: DevolutionModel | null = null;
  invoiceId: number | null = null;
  invoice: InvoiceModel | null = null;
  transporterId: number | null = null;
  vehicleId: number | null = null;
  orderId: number | null = null;
  order: OrderModel | null = null;
  swBlock: boolean = false;
  swInternalOrder: boolean = false;
  internalOrderId: number | null = null;
  internalOrder: InternalOrderModel | null = null;
  sendDateAccounting: string | null = null;
  createDate: Date = new Date();
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //variable para controlar si están limpiando el formulario:
  clearForm: boolean = true;
}
